var $ = jQuery.noConflict();
var PTEN = PTEN || {};
const formatCurrency = (n) => {
	if (n < 1e3) return n;
	if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(2) + "K";
	if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(2) + "M";
	if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(2) + "B";
	if (n >= 1e12) return +(n / 1e12).toFixed(2) + "T";
};
const formatNumerWithComma = (n) => {
	return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
(function ($) {
	"use strict";
	PTEN.initialize = {
		init: function () {
			PTEN.initialize.responsiveClasses();
			PTEN.initialize.tabWidget();
		},
		responsiveClasses: function () {
			if (typeof jRespond === "undefined") {
				console.log("responsiveClasses: jRespond not Defined.");
				return true;
			}

			var jRes = jRespond([
				{
					label: "smallest",
					enter: 0,
					exit: 575,
				},
				{
					label: "handheld",
					enter: 576,
					exit: 767,
				},
				{
					label: "tablet",
					enter: 768,
					exit: 991,
				},
				{
					label: "laptop",
					enter: 992,
					exit: 1199,
				},
				{
					label: "desktop",
					enter: 1200,
					exit: 10000,
				},
			]);
			jRes.addFunc([
				{
					breakpoint: "desktop",
					enter: function () {
						$body.addClass("device-xl");
					},
					exit: function () {
						$body.removeClass("device-xl");
					},
				},
				{
					breakpoint: "laptop",
					enter: function () {
						$body.addClass("device-lg");
					},
					exit: function () {
						$body.removeClass("device-lg");
					},
				},
				{
					breakpoint: "tablet",
					enter: function () {
						$body.addClass("device-md");
					},
					exit: function () {
						$body.removeClass("device-md");
					},
				},
				{
					breakpoint: "handheld",
					enter: function () {
						$body.addClass("device-sm");
					},
					exit: function () {
						$body.removeClass("device-sm");
					},
				},
				{
					breakpoint: "smallest",
					enter: function () {
						$body.addClass("device-xs");
					},
					exit: function () {
						$body.removeClass("device-xs");
					},
				},
			]);
		},
		tabWidget: function () {
			if (!$().tabs) {
				console.log("tabs: Tabs not Defined.");
				return true;
			}

			let $tabs = $(".tabs");
			if ($tabs.length > 0) {
				$tabs.each(function () {
					let element = $(this),
						elementSpeed = element.attr("data-speed"),
						tabActive = element.attr("data-active");

					if (!elementSpeed) {
						elementSpeed = 400;
					}
					if (!tabActive) {
						tabActive = 0;
					} else {
						tabActive = tabActive - 1;
					}

					let windowHash = window.location.hash;
					let windowHashText = "";
					if (jQuery(windowHash).length > 0) {
						windowHashText = windowHash.split("#");
						let tabItem = document.getElementById(windowHashText[1]);
						tabActive = jQuery(".tab-content").index(tabItem);
					}

					element.tabs({
						active: Number(tabActive),
						show: {
							effect: "fade",
							duration: Number(elementSpeed),
						},
					});
					element.find(".tab-linker").each(function () {
						var linker = $(this);
						if (
							jQuery(windowHash).length > 0 &&
							$(this).attr("rel") == windowHashText[1]
						) {
							linker.addClass("active");
						}
						linker.click(function () {
							//$('.tab-linker').removeClass('active');
							linker.toggleClass("active");
							return false;
						});
					});
				});
			}
		},
	};
	PTEN.header = {
		init: function () {
			PTEN.header.superfish();
			PTEN.header.menuFunction();
			PTEN.header.stickyMenu();
		},
		superfish: function () {
			if ($body.hasClass("device-xl") || $body.hasClass("device-lg")) {
				$("#primary-menu-top ul ul").css("display", "block");
				$("#primary-menu-top ul ul").css("display", "");

				if (!$().superfish) {
					$body.addClass("no-superfish");
					console.log("superfish: Superfish not Defined.");
					return true;
				}

				$("#primary-menu-top > ul").superfish({
					popUpSelector: "ul",
					delay: 250,
					speed: 350,
					animation: { opacity: "show" },
					animationOut: { opacity: "hide" },
					cssArrows: false,
					onShow: function () {},
				});
			}
		},
		stickyMenu: function (headerOffset) {
			if ($window.scrollTop() > headerOffset) {
				if ($body.hasClass("device-xl") || $body.hasClass("device-lg")) {
					$("#header:not(.no-sticky)").addClass("sticky-header");
				}
			} else {
				PTEN.header.removeStickyness();
			}
		},
		removeStickyness: function () {
			if ($header.hasClass("sticky-header")) {
				$("body:not(.side-header) #header:not(.no-sticky)").removeClass(
					"sticky-header",
				);
				$header.removeClass().addClass(oldHeaderClasses);
				$headerWrap.removeClass().addClass(oldHeaderWrapClasses);
			}
			if (
				$body.hasClass("device-sm") ||
				$body.hasClass("device-xs") ||
				$body.hasClass("device-md")
			) {
				$header.removeClass().addClass(oldHeaderClasses);
				$headerWrap.removeClass().addClass(oldHeaderWrapClasses);
			}
		},
		menuFunction: function () {
			$("#primary-menu ul li:has(ul)").addClass("sub-menu");
			if (
				$("#primary-menu").hasClass("on-click") ||
				$body.hasClass("device-md") ||
				$body.hasClass("device-sm") ||
				$body.hasClass("device-xs")
			) {
				$("#primary-menu li:has(ul) > a").on("click touchend", function (e) {
					var telem = $(this).parent(".sub-menu").siblings().find("ul");
					if (telem.length) {
						telem.slideUp("");
					}
					$(this).parent("li").children("ul").slideToggle();
					$(this).toggleClass("opened");
					e.preventDefault();
				});
			}
		},
	};
	PTEN.isMobile = {
		Android: function () {
			return navigator.userAgent.match(/Android/i);
		},
		BlackBerry: function () {
			return navigator.userAgent.match(/BlackBerry/i);
		},
		iOS: function () {
			return navigator.userAgent.match(/iPhone|iPad|iPod/i);
		},
		Opera: function () {
			return navigator.userAgent.match(/Opera Mini/i);
		},
		Windows: function () {
			return navigator.userAgent.match(/IEMobile/i);
		},
		any: function () {
			return (
				PTEN.isMobile.Android() ||
				PTEN.isMobile.BlackBerry() ||
				PTEN.isMobile.iOS() ||
				PTEN.isMobile.Opera() ||
				PTEN.isMobile.Windows()
			);
		},
	};
	PTEN.documentOnReady = {
		init: function () {
			PTEN.initialize.init();
			windowWidth = $window.width();
			PTEN.header.init();
			PTEN.documentOnReady.windowscroll();
			PTEN.documentOnReady.animations();
			PTEN.documentOnReady.jsSlider();
			PTEN.documentOnReady.linkScroll();
			let hash = window.location.hash;
			let headerHeight = $("#header").outerHeight() || 0;
			if ($("a[data-scrollto='" + hash + "']").length) {
				$("a[data-scrollto='" + hash + "']").click();
			}
			if (hash == "#investment-strategy") {
				$("html, body").animate(
					{
						scrollTop:
							$(hash).offset().top - PTEN.documentOnReady.topScrollOffset() - headerHeight,
					},
					1000,
				);
			} else if (hash && $(hash).length) {
				setTimeout(function() {
					$("html, body").animate(
						{
							scrollTop:
								$(hash).offset().top - PTEN.documentOnReady.topScrollOffset() - headerHeight,
						},
						1000,
					);
				}, 100);
			}
			$("#primary-menu-trigger")
				.off("click")
				.on("click", function () {
					$body.addClass("primary-menu-open");
					$html.addClass("no-scroll");
					$body.removeClass("primary-menu-hidden");
					return false;
				});
			$("#primary-menu-close, .menu-overlay")
				.off("click")
				.on("click", function () {
					$body.addClass("primary-menu-hidden");
					$html.removeClass("no-scroll");
					setTimeout(function () {
						$body.removeClass("primary-menu-open");
					}, 200);
					return false;
				});
			$(".video-controls").each(function () {
				$(this).on("click", function () {
					let $video = $(this).parent().find("video");
					if ($video.get(0).paused || $video.get(0).ended) {
						$video.get(0).play();
						$(this).parent().addClass("playing");
					} else {
						$video.get(0).pause();
						$(this).parent().removeClass("playing");
					}
				});
			});
			$(".video-container video").each(function () {
				$(this).on("pause", function () {
					if ($(this).get(0).paused) {
						$(this).parent().removeClass("playing");
					}
				});
			});

			if ($("#single-content").length) {
				PTEN.documentOnReady.scrollProgress();
				window.addEventListener("scroll", function (e) {
					PTEN.documentOnReady.scrollProgress();
				});
			}
			$(
				".page-banner .banner-content .info-block, .hero-banner.show_counters .counters .counter, .page-investment-strategy .counters .counter",
			).each(function () {
				if ($(this).hasClass("with-comma")) {
					$(this)
						.find(".num")
						.text(formatNumerWithComma($(this).data("number")));
				} else {
					$(this)
						.find(".num")
						.text(formatCurrency($(this).data("number")));
				}
			});
			$(document).on("click", ".blocks.clickable .block-item", function () {
				if (!$(this).hasClass("active")) {
					$(this).siblings().removeClass("active");
					$(this).addClass("active");
					let maxHeight = 0;
					$(".block-item .description").each(function () {
						let height = $(this).height();
						if (height > maxHeight) {
							maxHeight = height;
						}
					});
					$(".block-item .description").height(maxHeight);
				}
			});
			$(document).on(
				"click",
				".blocks.clickable .block-item .toggle-close",
				function (e) {
					let parent = $(this).parents(".block-item");
					let height = parent.height();
					parent.removeClass("active");
					parent.siblings().removeClass("hide");
					const dec_handler = setInterval(() => {
						if ($(this).height() <= 191) {
							height = 156;
							clearInterval(dec_handler);
						} else {
							height = height - 35;
						}
						parent.css("height", height + "px");
					}, 30);
					e.stopPropagation();
				},
			);
			$(".affiliate-box .btn-secondary").click(function (e) {
				e.stopPropagation();
			});
			$(".social-share .share-button-toggle").click(function (e) {
				var $toggle = $(this);
				var $socialShare = $toggle.closest(".social-share");
				var isActive = $toggle.hasClass("active");
				$toggle.toggleClass("active");
				$toggle.attr("aria-expanded", !isActive);
				// Add class to parent for CSS targeting
				if (!isActive) {
					$socialShare.addClass("share-expanded");
				} else {
					$socialShare.removeClass("share-expanded");
				}
			});

			// Social sharing functionality
			$(".social-share .share-btn").click(function (e) {
				e.preventDefault();
				var shareType = $(this).data("share");
				var $socialShare = $(this).closest(".social-share");
				var $btn = $(this);
				var url = $socialShare.data("url") || window.location.href;
				var title = $socialShare.data("title") || document.title;
				var excerpt = $socialShare.data("excerpt") || "";
				var shareUrl = "";

				// Blur button after click for better UX
				$btn.blur();

				switch (shareType) {
					case "copy":
						// Copy link to clipboard
						var copyUrl = $btn.data("copy-url") || url;
						copyToClipboard(copyUrl);
						return;

					case "linkedin":
						// LinkedIn sharing with title and summary
						var linkedinParams = {
							url: url,
							title: title
						};
						if (excerpt) {
							linkedinParams.summary = excerpt;
						}
						shareUrl = buildQueryString("https://www.linkedin.com/sharing/share-offsite/", linkedinParams);
						break;

					case "twitter": // X (formerly Twitter)
						shareUrl = buildQueryString("https://x.com/intent/tweet", {
							url: url,
							text: title
						});
						break;

					case "facebook":
						shareUrl = buildQueryString("https://www.facebook.com/sharer/sharer.php", {
							u: url
						});
						break;

					case "whatsapp":
						var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
							navigator.userAgent
						);
						var text = title + " " + url;
						if (isMobile) {
							shareUrl = buildQueryString("https://wa.me/", {
								text: text
							});
						} else {
							shareUrl = buildQueryString("https://web.whatsapp.com/send", {
								text: text
							});
						}
						break;

					case "email":
						shareUrl = buildQueryString("mailto:", {
							subject: title,
							body: url
						});
						break;

					case "sms":
						var smsBody = title + " " + url;
						shareUrl = "sms:?body=" + encodeURIComponent(smsBody);
						break;

					default:
						return;
				}

				if (shareUrl) {
					// Open share URL in new window for social platforms, same window for email/sms
					if (shareType === "email" || shareType === "sms") {
						window.location.href = shareUrl;
					} else {
						window.open(shareUrl, "_blank", "width=600,height=400");
					}
				}
			});

			/**
			 * Copy URL to clipboard with improved error handling
			 */
			function copyToClipboard(url) {
				if (navigator.clipboard && window.isSecureContext) {
					// Modern Clipboard API with secure context check
					navigator.clipboard.writeText(url)
						.then(function () {
							showCopyFeedback();
						})
						.catch(function (err) {
							console.error("Failed to copy: ", err);
							fallbackCopyTextToClipboard(url);
						});
				} else {
					// Fallback for older browsers or non-secure contexts
					fallbackCopyTextToClipboard(url);
				}
			}

			/**
			 * Fallback function for copying to clipboard in older browsers
			 */
			function fallbackCopyTextToClipboard(text) {
				var textArea = document.createElement("textarea");
				textArea.value = text;
				textArea.style.position = "fixed";
				textArea.style.left = "-999999px";
				textArea.style.top = "-999999px";
				document.body.appendChild(textArea);
				textArea.focus();
				textArea.select();

				try {
					var successful = document.execCommand("copy");
					if (successful) {
						showCopyFeedback();
					} else {
						console.error("Failed to copy: execCommand returned false");
					}
				} catch (err) {
					console.error("Failed to copy: ", err);
				}

				document.body.removeChild(textArea);
			}

			/**
			 * Show "Copied!" feedback message as centered overlay toast
			 */
			function showCopyFeedback() {
				// Remove existing toast if present
				$(".social-share-toast").remove();

				// Create toast message element
				var toast = $("<div>")
					.addClass("social-share-toast")
					.text("Copied!")
					.appendTo("body");

				// Remove toast after 2 seconds
				setTimeout(function () {
					toast.fadeOut(200, function () {
						$(this).remove();
					});
				}, 2000);
			}

			/**
			 * Build query string from object
			 */
			function buildQueryString(baseUrl, params) {
				var queryParts = [];
				for (var key in params) {
					if (params.hasOwnProperty(key) && params[key]) {
						queryParts.push(
							encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
						);
					}
				}
				return baseUrl + (queryParts.length > 0 ? "?" + queryParts.join("&") : "");
			}
			$(".wpforms-field input, .wpforms-field textarea").focus(function () {
				$(this).parent().addClass("focused");
			});
			$(".wpforms-field input, .wpforms-field textarea").blur(function () {
				$(this).parent().removeClass("focused");
			});
			var ptenBlogListingRequest = 0;
			var ptenBlogSearchRequest = 0;
			var ptenBlogPopstateBound = false;

			function ptenBindBlogPopstate() {
				if (ptenBlogPopstateBound) {
					return;
				}
				ptenBlogPopstateBound = true;
				window.addEventListener("popstate", function () {
					window.location.reload();
				});
			}

			function ptenFormUrl(form, omitEmpty) {
				var action = form.getAttribute("action");
				var url = action
					? new URL(action, window.location.href)
					: new URL(window.location.href);
				var params = new URLSearchParams();
				url.hash = "";
				new FormData(form).forEach(function (value, key) {
					if (omitEmpty && value === "") {
						return;
					}
					params.append(key, value);
				});
				url.search = params.toString();
				return url;
			}

			function ptenSyncSearchFilters(form) {
				var ordering = document.querySelector("main.site-main .posts-ordering");
				if (!ordering) {
					return;
				}
				["cat", "orderby", "order"].forEach(function (name) {
					var live = ordering.querySelector('[name="' + name + '"]');
					var value = live ? String(live.value).trim() : "";
					var hidden = form.querySelector('input[type="hidden"][name="' + name + '"]');
					if (!value) {
						if (hidden) {
							hidden.remove();
						}
						return;
					}
					if (!hidden) {
						hidden = document.createElement("input");
						hidden.type = "hidden";
						hidden.name = name;
						form.appendChild(hidden);
					}
					hidden.value = value;
				});
			}

			function ptenReplaceBlogListing(doc) {
				var current = document.querySelector("main.site-main .category-wrapper");
				var next = doc.querySelector("main.site-main .category-wrapper");
				if (!current || !next) {
					return false;
				}
				var currentCount = current.querySelector(".toolbar .count");
				var nextCount = next.querySelector(".toolbar .count");
				var currentToolbar = current.querySelector(".toolbar");
				var nextToolbar = next.querySelector(".toolbar");
				var currentResults = currentToolbar ? currentToolbar.nextElementSibling : null;
				var nextResults = nextToolbar ? nextToolbar.nextElementSibling : null;
				if (!currentCount || !nextCount || !nextResults) {
					return false;
				}
				currentCount.replaceWith(document.importNode(nextCount, true));
				if (currentResults) {
					currentResults.replaceWith(document.importNode(nextResults, true));
				} else {
					currentToolbar.after(document.importNode(nextResults, true));
				}
				var currentNav = current.querySelector('nav[aria-labelledby="posts-nav-label"]');
				var nextNav = next.querySelector('nav[aria-labelledby="posts-nav-label"]');
				if (currentNav && nextNav) {
					currentNav.replaceWith(document.importNode(nextNav, true));
				} else if (currentNav) {
					currentNav.remove();
				} else if (nextNav) {
					var container = current.querySelector(":scope > .container");
					if (container) {
						container.appendChild(document.importNode(nextNav, true));
					}
				}
				if (doc.title) {
					document.title = doc.title;
				}
				return true;
			}

			function ptenFetchBlogListing(form) {
				var requestId = ++ptenBlogListingRequest;
				var href = ptenFormUrl(form, false).toString();
				window
					.fetch(href, { credentials: "same-origin" })
					.then(function (response) {
						if (!response.ok) {
							throw new Error("Request failed");
						}
						return response.text();
					})
					.then(function (html) {
						if (requestId !== ptenBlogListingRequest) {
							return;
						}
						var doc = new DOMParser().parseFromString(html, "text/html");
						if (!ptenReplaceBlogListing(doc)) {
							form.submit();
							return;
						}
						window.history.pushState({ ptenBlogListing: true }, "", href);
						ptenBindBlogPopstate();
					})
					.catch(function () {
						if (requestId !== ptenBlogListingRequest) {
							return;
						}
						form.submit();
					});
			}

			$(".category-wrapper .toolbar select").customSelect({
				transition: 200,
			});
			$(document).on("submit", "form.blog-search", function (event) {
				if (typeof window.fetch !== "function" || typeof window.DOMParser !== "function") {
					return;
				}
				event.preventDefault();
				var form = this;
				var requestId = ++ptenBlogSearchRequest;
				ptenSyncSearchFilters(form);
				var href = ptenFormUrl(form, true).toString();
				window
					.fetch(href, { credentials: "same-origin" })
					.then(function (response) {
						if (!response.ok) {
							throw new Error("Request failed");
						}
						return response.text();
					})
					.then(function (html) {
						if (requestId !== ptenBlogSearchRequest) {
							return;
						}
						var doc = new DOMParser().parseFromString(html, "text/html");
						var nextMain = doc.querySelector("main.site-main");
						var currentMain = document.querySelector("main.site-main");
						if (!nextMain || !currentMain) {
							window.location.assign(href);
							return;
						}
						currentMain.replaceWith(document.importNode(nextMain, true));
						document.body.classList.add("search");
						document.body.classList.remove("blog");
						if (doc.body && doc.body.classList.contains("search-results")) {
							document.body.classList.add("search-results");
							document.body.classList.remove("search-no-results");
						} else if (doc.body && doc.body.classList.contains("search-no-results")) {
							document.body.classList.add("search-no-results");
							document.body.classList.remove("search-results");
						}
						if (doc.title) {
							document.title = doc.title;
						}
						window.scrollTo(0, 0);
						window.history.pushState({ ptenBlogSearch: true }, "", href);
						ptenBindBlogPopstate();
					})
					.catch(function () {
						if (requestId !== ptenBlogSearchRequest) {
							return;
						}
						window.location.assign(href);
					});
			});
			$(".posts-ordering").on("change", "select", function () {
				var form = $(this).closest("form").get(0);
				if ($body.hasClass("archive") && $(this).hasClass("filter-cat")) {
					window.location.href = $(this).val();
				} else if ($body.hasClass("blog") || $body.hasClass("archive")) {
					ptenFetchBlogListing(form);
				} else {
					form.submit();
				}
			});
			PTEN.documentOnReady.countAnimation();
		},
		topScrollOffset: function () {
			var topOffsetScroll = 0;
			if (
				($body.hasClass("device-xl") ||
					$body.hasClass("device-lg") ||
					$body.hasClass("device-md")) &&
				!PTEN.isMobile.any()
			) {
				topOffsetScroll = 80;
				if ($body.hasClass("admin-bar")) {
					topOffsetScroll += 32;
				}
			}
			if ($body.hasClass("device-sm") || $body.hasClass("device-xs")) {
				if ($body.hasClass("admin-bar")) {
					topOffsetScroll = 46;
				}
			}
			return topOffsetScroll;
		},
		linkScroll: function () {
			$("a[data-scrollto]")
				.off("click")
				.on("click", function () {
					var element = $(this),
						divScrollToAnchor = element.attr("data-scrollto"),
						divScrollSpeed = element.attr("data-speed"),
						divScrollOffset = element.attr("data-offset"),
						divScrollEasing = element.attr("data-easing"),
						divScrollHighlight = element.attr("data-highlight");
					if (element.parents("#primary-menu").hasClass("on-click")) {
						return true;
					}

					if (!divScrollSpeed) {
						divScrollSpeed = 750;
					}
					if (!divScrollOffset) {
						divScrollOffset = PTEN.documentOnReady.topScrollOffset();
					}
					if (!divScrollEasing) {
						divScrollEasing = "easeOutQuad";
					}
					if ($(".content-nav-wrapper").length) {
						divScrollOffset += 30;
						if ($(".page-investor-relations").length) {
							divScrollOffset += 82;
						}
					}
					$("html,body")
						.stop(true)
						.animate(
							{
								scrollTop:
									$(divScrollToAnchor).offset().top - Number(divScrollOffset),
							},
							Number(divScrollSpeed),
							divScrollEasing,
							function () {
								if (divScrollHighlight) {
									if ($(divScrollToAnchor).find(".highlight-me").length > 0) {
										$(divScrollToAnchor)
											.find(".highlight-me")
											.animate({ backgroundColor: divScrollHighlight }, 300);
										var t = setTimeout(function () {
											$(divScrollToAnchor)
												.find(".highlight-me")
												.animate({ backgroundColor: "transparent" }, 300);
										}, 500);
									} else {
										$(divScrollToAnchor).animate(
											{ backgroundColor: divScrollHighlight },
											300,
										);
										var t = setTimeout(function () {
											$(divScrollToAnchor).animate(
												{ backgroundColor: "transparent" },
												300,
											);
										}, 500);
									}
								}
							},
						);

					return false;
				});
		},
		countAnimation: function () {
			const animationDuration = 2000;

			const frameDuration = 1000 / 60;

			const totalFrames = Math.round(animationDuration / frameDuration);

			const easeOutQuad = (t) => t * (2 - t);

			const animateCountUp = (el) => {
				let frame = 0;
				const countTo = $(el).hasClass("no-round")
					? parseFloat(el.dataset.number)
					: parseInt(el.dataset.number, 10);
				// Start the animation running 60 times per second
				const counter = setInterval(() => {
					frame++;

					const progress = easeOutQuad(frame / totalFrames);
					const currentCount = $(el).hasClass("no-round")
						? (countTo * progress).toFixed(1)
						: Math.round(countTo * progress);

					if (parseInt($(el).find(".num").text(), 10) !== currentCount) {
						if ($(el).hasClass("with-comma")) {
							$(el).find(".num").text(formatNumerWithComma(currentCount));
						} else {
							$(el).find(".num").text(formatCurrency(currentCount));
						}
					}
					if (frame === totalFrames) {
						clearInterval(counter);
					}
				}, frameDuration);
			};

			const countupEls = document.querySelectorAll(
				".page-banner .banner-content .infos .info-block, .hero-banner.show_counters .counters .counter, .page-investment-strategy .counters .counter",
			);
			countupEls.forEach(animateCountUp);
		},
		scrollProgress: function () {
			const cw =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;
			const minwidth = cw / 2 - $("#single-content").width() / 2 + 50;
			let scrolltop = $window.scrollTop() + $("#header-wrap").height();
			if ($("body").hasClass("admin-bar")) {
				scrolltop = scrolltop + $("#wpadminbar").height();
			}
			if (scrolltop > $("#single-content").offset().top) {
				$("#scroll-progress").addClass("fixed");
			} else {
				$("#scroll-progress").removeClass("fixed");
			}
			//let w = (document.body.scrollTop || document.documentElement.scrollTop) / (document.documentElement.scrollHeight - document.documentElement.clientHeight - $('#footer').height()) * 100;
			let w =
				window.scrollY /
				(document.getElementById("single-content").offsetHeight -
					window.innerHeight);
			let wp = w > 1 ? (w = 100) : Math.round(w * 100);
			if ((cw * wp) / 100 >= minwidth) {
				$("#scroll-progress").css("width", wp + "%");
			} else {
				$("#scroll-progress").css("width", minwidth + "px");
			}
		},
		equalizeSliderCards: function (element) {
			if (element.data("ptenEqualizing")) {
				return;
			}
			element.data("ptenEqualizing", true);
			[".post-categories", ".title", ".meta-info"].forEach(function (selector) {
				var items = element.find(".slick-slide:not(.slick-cloned) " + selector);
				items.css("min-height", "");
				var max = 0;
				items.each(function () {
					max = Math.max(max, Math.ceil($(this).outerHeight()));
				});
				element
					.find(".slick-slide " + selector)
					.css("min-height", max ? max + "px" : "");
			});
			window.requestAnimationFrame(function () {
				element.data("ptenEqualizing", false);
			});
		},
		jsSlider: function () {
			$(".js-slider").each(function () {
				var element = $(this);
				var options = $(this).data("slick");
				options = $.extend(options, {
					responsive: [
						{
							breakpoint: 1470,
							settings: {
								slidesToShow: $(this).data("show-lg")
									? $(this).data("show-lg")
									: 1,
								slidesToScroll: 1,
							},
						},
						{
							breakpoint: 992,
							settings: {
								slidesToShow: $(this).data("show-md")
									? $(this).data("show-md")
									: 1,
								slidesToScroll: 1,
								arrows: false,
							},
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: $(this).data("show-sm")
									? $(this).data("show-sm")
									: 1,
								slidesToScroll: 1,
								arrows: false,
							},
						},
						{
							breakpoint: 480,
							settings: {
								slidesToShow: $(this).data("show-xs")
									? $(this).data("show-xs")
									: 1,
								slidesToScroll: 1,
								arrows: false,
							},
						},
					],
				});
				element.on("setPosition", function () {
					if (element.data("ptenEqualizing")) {
						return;
					}
					window.cancelAnimationFrame(element.data("ptenEqualizeFrame"));
					element.data(
						"ptenEqualizeFrame",
						window.requestAnimationFrame(function () {
							PTEN.documentOnReady.equalizeSliderCards(element);
						}),
					);
				});
				element.slick(options);
				if (document.fonts && document.fonts.ready) {
					document.fonts.ready.then(function () {
						PTEN.documentOnReady.equalizeSliderCards(element);
					});
				}
			});
		},
		windowscroll: function () {
			var headerWrapOffset = 0;
			if ($header.length > 0) {
				headerWrapOffset = $headerWrap.offset().top;
			}

			PTEN.header.stickyMenu(headerWrapOffset);

			$window.on("scroll", function () {
				PTEN.header.stickyMenu(headerWrapOffset);
				let top = window.scrollY;
				let tsection = $(".page-team, .page-investor-relations");
				if (tsection.length) {
					let tOffset =
						tsection.offset().top - PTEN.documentOnReady.topScrollOffset();
					if (
						tsection.length &&
						top >= tOffset &&
						top < tOffset + tsection[0].offsetHeight
					) {
						$(".content-nav-wrapper").addClass("sticky-content");
						$(".tabbed-content").each(function () {
							let element = $(this);
							let offset =
								element.offset().top -
								PTEN.documentOnReady.topScrollOffset() -
								31;
							if ($(".page-investor-relations").length) {
								offset -= 90;
							}
							let height = element[0].offsetHeight;
							let id = element.attr("id");
							if (top >= offset && top < offset + height) {
								let elem =
									'.content-nav-wrapper a[data-scrollto="#' + id + '"]';
								$(".content-nav-wrapper a").removeClass("active");
								$(elem).addClass("active");
							}
						});
					} else {
						$(".content-nav-wrapper").removeClass("sticky-content");
						$(".content-nav-wrapper a").removeClass("active");
					}
				}
				let counter = $(".page-investment-strategy .counters");
				if (counter.length && counter.hasClass("not-animated")) {
					PTEN.documentOnReady.countAnimation();
				}
			});
		},
		animations: function () {
			if (!$().appear) {
				console.log("animations: Appear not Defined.");
				return true;
			}

			var $dataAnimateEl = $("[data-animate]");
			if ($dataAnimateEl.length > 0) {
				//if( $body.hasClass('device-xl') || $body.hasClass('device-lg') || $body.hasClass('device-md') ){
				$dataAnimateEl.each(function () {
					var element = $(this),
						animationOut = element.attr("data-animate-out"),
						animationDelay = element.attr("data-delay"),
						animationDelayOut = element.attr("data-delay-out"),
						animationDelayTime = 0,
						animationDelayOutTime = 3000;

					if (animationDelay) {
						animationDelayTime = Number(animationDelay) + 500;
					} else {
						animationDelayTime = 150;
					}
					if (animationOut && animationDelayOut) {
						animationDelayOutTime =
							Number(animationDelayOut) + animationDelayTime;
					}

					if (!element.hasClass("animated")) {
						// If element is already in view on initial paint, don't hide it.
						// Hiding above-the-fold elements with `.not-animated` (opacity:0) causes a flash that looks like a reload.
						var inViewNow = false;
						try {
							var vh =
								window.innerHeight ||
								(document.documentElement
									? document.documentElement.clientHeight
									: 0) ||
								0;
							var rect = element[0] && element[0].getBoundingClientRect
								? element[0].getBoundingClientRect()
								: null;
							if (rect) {
								inViewNow =
									rect.top < vh && rect.bottom > 0;
							}
						} catch (e) {}

						if (inViewNow) {
							element.removeClass("not-animated").addClass("animated");
							return;
						}

						element.addClass("not-animated");
						var elementAnimation = element.attr("data-animate");
						element.appear(
							function () {
								setTimeout(function () {
									element
										.removeClass("not-animated")
										.addClass(elementAnimation + " animated");
								}, animationDelayTime);

								if (animationOut) {
									setTimeout(function () {
										element
											.removeClass(elementAnimation)
											.addClass(animationOut);
									}, animationDelayOutTime);
								}
							},
							{ accX: 0, accY: -120 },
							"easeInCubic",
						);
					}
				});
				//}
			}
		},
	};
	PTEN.documentOnLoad = {
		init: function () {},
	};
	PTEN.documentOnResize = {
		init: function () {
			windowWidth = $window.width();
			if (PTEN.isMobile.any()) {
				$body.addClass("device-touch");
			}
			if ($("#single-content").length) {
				PTEN.documentOnReady.scrollProgress();
			}
		},
	};
	var $window = $(window),
		$header = $("#header"),
		$headerWrap = $("#header-wrap"),
		oldHeaderClasses = $header.attr("class"),
		oldHeaderWrapClasses = $headerWrap.attr("class"),
		$body = $("body"),
		$html = $("html"),
		windowWidth;

	$(document).ready(PTEN.documentOnReady.init);
	$window.on("load", PTEN.documentOnLoad.init);
	$window.on("resize", PTEN.documentOnResize.init);
})(jQuery);
